import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { IUserInfo } from '@/types/store';
import BidForm from '@/components/BidView/BidForm.vue';
import BidViewActions from '@/components/BidView/BidViewActions.vue';
import BidViewBidders from '@/components/BidView/BidViewBidders.vue';
import BidViewAuctionInfo from '@/components/BidView/BidViewAuctionInfo.vue';
import BidViewCorporateClient from '@/components/BidView/BidViewCorporateClient.vue';
import BidViewLawFirm from '@/components/BidView/BidViewLawFirm.vue';

// #constants

export default /*@__PURE__*/_defineComponent({
  __name: 'BidView',
  setup(__props) {

const { dispatch, getters } = useStore();

// #data
const isLoading = ref<boolean>(false);
const companyGrant = ref<any>({});

// #computed
const getCurrency = computed<string>(() => {
  const { currency = '' } = getAsset.value ?? {};
  return currency;
});
const getUser = computed<IUserInfo>(() => {
  return getters['getUser'];
});
const getAsset = computed(() => {
  return getters['getAsset'];
});
const getIsNeedShowAssetBidders = computed(() => {
  return getters['getIsNeedShowAssetBidders'];
});
const getBiddersToRendering = computed(() => {
  return getters['getBiddersToRendering'];
});
const getHeadersToRendering = computed(() => {
  return getters['getHeadersToRendering'];
});
const assetId = computed<string>(() => {
  const { id = '' } = getAsset.value ?? {};
  return id;
});
const companyId = computed<string>(() => {
  const {
    company = {
      id: ''
    }
  } = getUser.value ?? {};
  const { id = '' } = company ?? {};
  return id;
});
const isDisabledForm = computed(() => {
  const { id = '' } = getUser.value ?? {};
  const {
    draftPreBid = {
      userId: ''
    },
    preBid = {
      userId: ''
    }
  } = companyGrant.value ?? {};
  const { userId: draftUserId = '' } = draftPreBid ?? {};
  const { userId: preBidUserId = '' } = preBid ?? {};
  const isPatrticipant = [draftUserId, preBidUserId].includes(id);

  if (draftUserId || preBidUserId) {
    return isPatrticipant;
  }

  return true;
});

// #methods
const getCompanyGrantData = async () => {
  if (!assetId.value || !companyId.value) return;
  isLoading.value = true;
  try {
    const { data } = await dispatch('getCompanyGrant', {
      assetId: assetId.value,
      companyId: companyId.value
    });
    const { getCompanyGrant = {} } = data ?? {};
    companyGrant.value = getCompanyGrant;
  } catch (error) {
    console.error('getCompanyGrant error:', error);
  } finally {
    isLoading.value = false;
  }
};

const getProposal = async () => {
  if (!assetId.value || !companyId.value) {
    return;
  }
  try {
    await dispatch('getProposal', {
      assetId: assetId.value
    });
  } catch (error) {
    console.error('Failed to get proposal:', error);
  }
};

// Hooks
watch(
  [assetId, companyId],
  async ([newAssetId, newCompanyId]) => {
    if (newAssetId && newCompanyId) {
      await Promise.all([getCompanyGrantData(), getProposal()]);
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "mt-10" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "9" }, {
        default: _withCtx(() => [
          _createVNode(BidForm, {
            "is-disabled-form": !isDisabledForm.value || isLoading.value
          }, null, 8, ["is-disabled-form"]),
          _createVNode(BidViewActions, {
            class: "mt-6",
            "is-disabled-form": !isDisabledForm.value || isLoading.value
          }, null, 8, ["is-disabled-form"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "3" }, {
        default: _withCtx(() => [
          _createVNode(BidViewAuctionInfo, null, _createSlots({ _: 2 }, [
            (getIsNeedShowAssetBidders.value)
              ? {
                  name: "biddersTable",
                  fn: _withCtx(() => [
                    _createVNode(BidViewBidders, {
                      "get-headers-to-rendering": getHeadersToRendering.value,
                      bidders: getBiddersToRendering.value,
                      currency: getCurrency.value
                    }, null, 8, ["get-headers-to-rendering", "bidders", "currency"])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1024),
          _createVNode(BidViewCorporateClient, { class: "mt-6" }),
          _createVNode(BidViewLawFirm, { class: "mt-6" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})